import { render, staticRenderFns } from "./CampaignOrderCard.vue?vue&type=template&id=3ff9bcac&scoped=true"
import script from "./CampaignOrderCard.vue?vue&type=script&lang=js"
export * from "./CampaignOrderCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignOrderCard.vue?vue&type=style&index=0&id=3ff9bcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9bcac",
  null
  
)

/* custom blocks */
import block0 from "./CampaignOrderCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports